import React from "react";
import Headerr from "./Headerr";
import "../../../assets/css/Contact.css";
import Footer from "../Footer";
import { Link } from "react-router-dom";
import NoCopyWrapper from "../../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../../utils/NoZoomWrapper";
const Contact = () => {
  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <Headerr />
          <div className="contact-headers">
            <h1>Contact Us</h1>
            <p>
              <Link to="/" className="Contact-home">
                Home
              </Link>{" "}
              /<span className="breadcrumb-Contact">Contact</span>
            </p>
          </div>

          <div className="contact-info">
            <div className="contact-card">
              <i className="fas fa-phone"></i>
              <h4>Phone</h4>
              <p>+91 99799 55319</p>
            </div>

            <div className="contact-card">
              <i className="fas fa-envelope"></i>
              <h4>E-Mail</h4>
              <p>contact@rentel.in</p>
            </div>

            <div className="contact-card">
              <i className="fas fa-map-marker-alt"></i>
              <h4>Address</h4>
              <p>
                MBC Shoping, Mota Varachha, Surat
                <br />
                Gujrat 394101
              </p>
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Contact;
